import { Alert, Card, CardContent, Chip, CircularProgress, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useMisAportes } from '../hooks/useMisDatos';
import { EstadoPagoChip } from '../components/Chips';
import { formatCurrency, formatPeriodo } from '../utils/format';

export default function MisAportes() {
  const { data, isLoading, error } = useMisAportes();
  const aportes = data ?? [];

  return (
    <Stack spacing={2}>
      <div>
        <Typography variant="h5" fontWeight={700}>
          Mis aportes
        </Typography>
        <Typography color="text.secondary">Lo que tu empresa declaró y aportó por vos en cada período.</Typography>
      </div>
      {isLoading && <CircularProgress size={28} />}
      {error && <Alert severity="error">No pudimos cargar tus aportes. Probá de nuevo en unos minutos.</Alert>}
      {!isLoading && !error && aportes.length === 0 && (
        <Alert severity="info">Todavía no hay aportes registrados a tu nombre.</Alert>
      )}
      {aportes.length > 0 && (
        <Card>
          <CardContent sx={{ p: { xs: 0, sm: 1 } }}>
            <TableContainer>
              <Table size="medium" aria-label="Aportes por período">
                <TableHead>
                  <TableRow>
                    <TableCell>Período</TableCell>
                    <TableCell>Empresa</TableCell>
                    <TableCell align="right">Aporte</TableCell>
                    <TableCell>Estado</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {aportes.map((a) => (
                    <TableRow key={a.planilla_id}>
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>
                        {formatPeriodo(a.periodo)} {a.excepcional && <Chip size="small" label="Excepcional" sx={{ ml: 0.5 }} />}
                      </TableCell>
                      <TableCell>{a.empresa}</TableCell>
                      <TableCell align="right" sx={{ fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>
                        {formatCurrency(a.aporte)}
                      </TableCell>
                      <TableCell>
                        <EstadoPagoChip estado={a.estado_pago} />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      )}
    </Stack>
  );
}
